import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import apiObj from '@a/js/api.js'
import storeLocal from 'storejs'

// 样式重置
import '@/assets/styles/reset.css'
import '@/assets/styles/public.css'
import '@/assets/fonts/remixicon.css'
// 表单公共样式
import '@/assets/styles/formSty.less'
import '@/assets/styles/pcsty.less'
Vue.config.devtools = apiObj.VUE_APP_NAME !== 'production'

import {
  Button,
  Toast,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Picker,
  Popup,
  DatetimePicker,
  Area,
  Uploader,
  NumberKeyboard,
  Stepper,
  Icon,
  Notify,
  Form,
  Loading,
  Divider,
  Overlay,
  CountDown,
  Dialog
} from 'vant'

Vue.use(Button)
Vue.use(Toast)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Area)
Vue.use(Uploader)
Vue.use(NumberKeyboard)
Vue.use(Stepper)
Vue.use(Icon)
Vue.use(Notify)
Vue.use(Form)
Vue.use(Loading)
Vue.use(Divider)
Vue.use(Overlay)
Vue.use(CountDown)
Vue.use(Dialog)
Vue.config.productionTip = false
Vue.prototype.$AppName = 'ticket'
Vue.prototype.$storeLocal = storeLocal

new Vue({
  router,
  data: () => {
    return {
      isVersion: 0,
    }
  },
  render: h => h(App)
}).$mount('#app')
